var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 199.37537,
    viewBox: "0 0 40 199.37537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #333;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pc"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 13.33405,
    width: 34.81482,
    height: 4.44373
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 35.40375,
    width: 34.81482,
    height: 4.44373
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "40 57.77124 40 53.32745 34.81482 53.32745 34.81482 48.8858 30.37109 48.8858 30.37109 53.32745 4.44379 53.32745 4.44379 53.32648 0 53.32648 0 53.32745 0 57.77124 0 64.43585 4.44379 64.43585 4.44379 57.77124 30.37109 57.77124 30.37109 66.66083 34.81482 66.66083 34.81482 57.77124 40 57.77124"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "40 116.13031 40 111.68658 34.81482 111.68658 34.81482 107.2428 40 107.2428 40 102.79901 34.81482 102.79901 34.81482 98.35529 30.37109 98.35529 30.37109 111.68658 0 111.68658 0 116.13031 30.37109 116.13031 30.37109 120.57404 34.81482 120.57404 34.81482 116.13031 40 116.13031"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 166.34418,
    width: 34.81482,
    height: 4.44373
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 194.93158,
    width: 34.81482,
    height: 4.44379
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "34.81482 82.65436 34.81482 73.02625 30.37109 73.02625 30.37109 82.65436 0 82.65436 0 87.09814 30.37109 87.09814 30.37109 92.28247 34.81482 92.28247 34.81482 87.09814 34.81482 82.65436"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "34.81482 131.23834 34.82605 131.23834 34.82605 126.79462 34.81482 126.79462 30.37109 126.79462 25.93854 126.79462 25.93854 131.23834 30.37109 131.23834 30.37109 140.12585 0 140.12585 0 144.56958 30.37109 144.56958 34.81482 144.56958 34.81482 140.12585 34.81482 131.23834"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "40 2.59216 40 0 37.40784 0 34.81561 0 34.81561 2.59216 34.81561 5.18439 37.40784 6.95917 40 5.18439 40 2.59216"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "31.11115 2.59216 31.11115 0 28.51892 0 25.92676 0 25.92676 2.59216 25.92676 5.18439 28.51892 6.95917 31.11115 5.18439 31.11115 2.59216"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "40 155.60504 40 153.01288 37.40784 153.01288 34.81561 153.01288 34.81561 155.60504 34.81561 158.19727 37.40784 159.97205 40 158.19727 40 155.60504"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "31.11115 155.60504 31.11115 153.01288 28.51892 153.01288 25.92676 153.01288 25.92676 155.60504 25.92676 158.19727 28.51892 159.97205 31.11115 158.19727 31.11115 155.60504"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "40 26.88647 40 24.29431 37.40784 24.29431 34.81561 24.29431 34.81561 26.88647 34.81561 29.4787 37.40784 31.25348 40 29.4787 40 26.88647"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "40 179.74878 40 177.15656 37.40784 177.15656 34.81561 177.15656 34.81561 179.74878 34.81561 182.34094 37.40784 184.11572 40 182.34094 40 179.74878"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "40 188.58337 40 186.04407 37.46075 186.04407 34.92145 186.04407 34.92145 188.58337 34.92145 191.12268 37.46075 192.89746 40 191.12268 40 188.58337"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.165534623bb58dae785e108ebcea9f94.svg";
export { ForwardRef as ReactComponent };